<template>
  <div class="ml-2 mr-2">
    <div
      id="checkoutBox"
      v-bind:class="{ errorShake: isErrorShake }"
      class="mt-6"
      style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 10px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
    >
      <h1 style="text-align: center;" class="mb-3">Complete Payment</h1>

      <div v-if="this.message != ''">
        <v-alert type="success" v-bind="this.message" style="font-weight: bold;">{{this.message}}</v-alert>
      </div>

      <div v-if="this.error != ''">
        <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
      </div>

      <p style="text-align: center; font-weight:bold;">Charge Total: ${{this.totalDollarAmount}}</p>

      <p style="padding: 0px; margin: 0px; font-weight: bold;">Enter Credit or Debit Card</p>

      <form id="payment-form" style="padding: 0px; margin: 0px; background-color: none !important;">
        <div class="form-row">
          <div id="card-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>

          <!-- Used to display form errors. -->
          <div id="card-errors" role="alert" style="font-weight: bold;"></div>
        </div>

        <div style="width: 60%; margin: 0 auto;" v-if="this.error == ''">
          <v-btn
            id="submitButton"
            class="mt-5 mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            @click="submit"
          >Submit Order!</v-btn>
        </div>

        <div style="width: 60%; margin: 0 auto;" v-if="this.error != ''">
          <v-btn
            id="submitButton"
            class="mt-5 mb-2"
            style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
            height="50"
            color="success"
            disabled="true"
            @click="submitOrder"
          >Submit Order!</v-btn>
        </div>
      </form>
    </div>

    <p
      class="mt-5 ml-2 mr-2"
      style="text-align: center;"
    >Your sticker will be printed in 1 business day and will arrive after 2-5 business days.</p>

    <h2 class="mt-5" style="text-align: center;">Shipping Address</h2>
    <div style="height: 1px; width: 80%;background-color: black; margin: 0 auto;"></div>

    <div style="width: 300px; margin: 0 auto; text-align: center;">
      <div style="margin 0 auto; text-align: center">
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">Name:</span>
          {{$store.state.shippingInfo.name}}
        </p>
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">Line 1:</span>
          {{$store.state.shippingInfo.address1}}
        </p>
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">Line 2:</span>
          {{$store.state.shippingInfo.address2}}
        </p>
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">City:</span>
          {{$store.state.shippingInfo.city}}
        </p>
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">State:</span>
          {{$store.state.shippingInfo.state}}
        </p>
        <p style="text-align: left; padding: 0px; margin: 0px">
          <span style="font-weight: bold;">Zipcode:</span>
          {{$store.state.shippingInfo.zipcode}}
        </p>
      </div>
    </div>

    <h2 class="mt-5" style="text-align: center;">Order Summary</h2>

    <div style="height: 1px; width: 80%;background-color: black; margin: 0 auto;"></div>

    <v-container
      v-for="(item) in this.cartItems"
      :key="item.id"
      style="padding: 0px; margin: 0 auto; max-width: 600px;"
    >
      <h4 style="text-align: center;" class="mb-3 mt-2">{{item.title}}</h4>
      <div style="width: 100px; margin: 0 auto; text-align: center;" class="mb-1">
        <img v-bind:src="item.thumbnail" style="width: 100px; margin: 0 auto; text-align: center;" />
      </div>
      <v-row no-gutters class="ml-5 mr-5 cartBox" style="text-align: center;">
        <v-col cols="12" sm="1" md="2" lg="2">
          <p>{{item.kind}}</p>
        </v-col>

        <v-col cols="12" sm="3" md="2" lg="2">
          <p>
            <span style="font-weight: bold;">Size:</span>
            {{item.size}}
          </p>
        </v-col>

        <v-col cols="12" sm="6" md="5" lg="5" class="mb-4">
          <v-btn
            class
            style="box-shadow: 0 0 5px rgb(150, 150, 150); min-width: 25px; height: 25px;"
          >Quantity: {{item.quantity}}</v-btn>
        </v-col>

        <v-col cols="12" sm="2" md="3" lg="3">
          <p>
            <span style="font-weight: bold;">Price:</span>
            ${{item.dollarAmount}}
          </p>
        </v-col>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-2"></div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data: () => ({
    email: "",
    password: "",
    total: 0,
    totalDollarAmount: 0,
    cartItems: [],
    token: "",
    error: "",
    message: "",
    isErrorShake: false,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  mounted() {
    this.scrollToTop();
    this.$store.state.cart.forEach(item => {
      item.dollarAmount = item.quantity * item.price;
      this.total = this.total + item.dollarAmount;
      item.dollarAmount = item.dollarAmount / 100;
      this.cartItems.push(item);
    });

    let total = this.total;
    this.totalDollarAmount = this.total / 100;

    // Create a Stripe client.
    if (process.env.NODE_ENV === "development") {
      // Testing key
      var stripe = Stripe("pk_test_5xRVjZogBfBH95U6iTgqArAb00LhUUzWEu");
    } else {
      // Live key
      var stripe = Stripe("pk_live_tybi1TW5Wu1zYwme2uTAkBRs007QGuJAp5");
    }

    // Create an instance of Elements.
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };

    // Create an instance of the card Element.
    var card = elements.create("card", { style: style });

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount("#card-element");

    // Handle real-time validation errors from the card Element.
    card.addEventListener("change", event => {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        // displayError.textContent = event.error.message;
        this.error = event.error.message;
      } else {
        // displayError.textContent = "";
        this.error = "";
      }
    });

    // Handle form submission.
    var button = document.getElementById("submitButton");
    button.addEventListener("click", event => {
      event.preventDefault();

      stripe.createToken(card).then(result => {
        if (result.error) {
          this.error = result.error.message;
        } else {
          // Send the token to your server.
          this.stripeTokenHandler(result.token);
        }
      });
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    confirmationPage() {
      this.$router.push("/confirmation");
    },
    async stripeTokenHandler(token) {
      try {
        this.message = "Submitting payment...";
        // TODO: Go to backend and add UUID to response and send that in afterCharge
        const response = await UserService.charge({
          total: this.total,
          token: token.id
        });
        this.afterCharge();
      } catch (error) {
        this.message = "";
        this.error = error.response.data.error;
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      }
    },
    async afterCharge() {
      try {
        // TODO make sure email address is getting sent for logged in user too
        // Maybe set the email address when the dispatch is made to set the address
        let orderEmail;
        if (this.$store.state.isUserLoggedIn) {
          orderEmail = this.$store.state.user.email;
        } else {
          orderEmail = this.$store.state.shippingInfo.email;
        }
        const response = await UserService.order({
          email: orderEmail,
          total: this.total,
          items: this.cartItems,
          address: this.$store.state.shippingInfo
        });
        await UserService.emailConfirmation({
          email: orderEmail,
          total: this.total,
          items: this.cartItems,
          address: this.$store.state.shippingInfo
        });
      } catch (error) {
        this.error = error.response.data.error;
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      }

      this.$store.dispatch(
        "addToTotalInCart",
        -1 * this.$store.state.totalNumberInCart
      );
      this.$store.dispatch("setEntireCart", []);
      this.$router.push("/confirmation");
    }
  }
};
</script>


<style scoped>
#confirmationBox {
  text-align: center;
  margin-top: 30px;
}

.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid rgb(130, 130, 130);
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #ff3710;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.errorForm {
  border: 1px solid red !important;
}

.errorShake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.75s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
